import xmljs from "xml-js";

import type {TelementState, TuiState} from "../types/uiapp.d.ts";
import type {TelementJSON} from "../types/Iuigen.d.ts";

const { rz } = window;

const uimin = {
  ConvertSubXMLtoJSON: (xml) => {
    let jsnt:xmljs.Element | xmljs.ElementCompact;
    try { jsnt = xmljs.xml2js(xml, {compact: false}) } catch (err) { console.log(err); return null }
    if (!jsnt || !jsnt.elements || !jsnt.elements[0] || !jsnt.elements[0].attributes?.key || !jsnt.elements[0].name) { console.log("ConvertSubXMLtoJSON() -> Incorrect sub-xml-template"); return null }
    return jsnt.elements[0].elements;
  },

  expandUIstate: (appState:TuiState, rootPath:string, elements:TelementJSON[]) => {
    const ans = {...appState}; // rz.objClone(appState); - Так нельзя! Иначе убьем все value (у тегов div), где хранились React-элементы
    // const rootNamespace = window[rootElement.attributes.key];

    const buildFlatState = (parseElements:TelementJSON[], parentPath?:string) => {
      if (parseElements && parseElements.length) {
        parseElements.forEach((nextEl, i) => {
          if (nextEl && nextEl.name && nextEl.type) {
            if (nextEl.type === "element") {
              const curPath = (nextEl?.attributes?.key ? nextEl.attributes.key : nextEl.name + (!rz.arrContains(["en", "ru", "tr"], nextEl.name) ? "[" + i + "]" : ""));
              const fullPath = (parentPath ? parentPath + "/" : "") + curPath;
              const fltSt:TelementState = {
                key: nextEl.attributes?.key, name: nextEl.name, shortPath: curPath, fullPath,
                userStyle: (nextEl.attributes && nextEl.attributes.style ? rz.parseCSSText(nextEl.attributes.style) : {}),
                userClass: rz.arrGetUnique((nextEl.attributes?.class || "").split(" "), true, true, true),
                attributes: {}
              };
              // Special Elements Definitions
              if (nextEl.name === "aggrid") {
                fltSt.data = []; fltSt.loading = true; fltSt.specialParams = {columnDefs: (new Date()).getTime()};
              }
              if (nextEl.name === "canvas") {
                fltSt.data = []; fltSt.loading = true; fltSt.specialParams = {rendered: (new Date()).getTime()};
              }
              if (nextEl.name === "chart" || nextEl.name === "chartjs") {
                fltSt.data = []; fltSt.loading = true;
              }
              if (rz.arrContains(["list", "approval", "chat"], nextEl.name)) {
                fltSt.data = [];
              }
              else if (nextEl.name === "upload") {
                fltSt.value = [];
              }
              else if (nextEl.name === "image") {
                fltSt.items = [];
              }
              else if (~["tabs", "accordions", "steps", "segmented"].indexOf(nextEl.name)) {
                const vlu = nextEl.attributes?.value || (nextEl.elements && nextEl.elements[0] && nextEl.elements[0].attributes?.key);
                if (vlu) { fltSt.value = vlu }
              }
              else if (nextEl.name === "style" || nextEl.name === "docviewer") {
                fltSt.value = "";
                // Detect text inside <style>...</style>
                const texts = (nextEl.elements || []).filter((el1:TelementJSON) => (el1?.type === "text")).map((el1:TelementJSON) => (el1?.text || ""));
                if (texts && texts[0]) { fltSt.value = texts[0] }
              }

              // Parse Attributes
              if (nextEl.attributes) {
                fltSt.attributes = {...nextEl.attributes}; // rz.objDeleteKeys(nextEl.attributes, ["value", "visible", "disabled", "loading", "style", "class"]);
                const attrKeys = (rz.isObject(nextEl.attributes) && rz.objKeys(nextEl.attributes)) || [];
                // Optional attributes:
                if (~attrKeys.indexOf("value")) {
                  const v1 = nextEl.attributes.value;
                  if (rz.isString(v1) && v1.startsWith("{") && v1.endsWith("}")) { const jsnb = (rz.strReplaceAll(v1, "'", "\"")).trim(); let jsn; try { jsn = JSON.parse(jsnb) } catch (err) { console.log(err) } fltSt.value = jsn || v1 }
                  else if (nextEl.name === "switch") { fltSt.value = (v1 === "true") }
                  else { fltSt.value = v1 }
                }
                if (~attrKeys.indexOf("items") || ~attrKeys.indexOf("options")) {
                  const v1 = nextEl.attributes.items || nextEl.attributes.options;
                  if (v1 && rz.isString(v1)) {
                    if (v1.startsWith("{") && v1.endsWith("}")) {
                      const jsnb = (rz.strReplaceAll(v1, "'", "\"")).trim(); let jsn; try { jsn = JSON.parse(jsnb) } catch (err) { console.log(err) }
                      if (jsn?.items && rz.isArray(jsn.items)) { fltSt.items = jsn.items }
                      else if (jsn?.options && rz.isArray(jsn.options)) { fltSt.items = jsn.options }
                    } else { fltSt.items = v1.split("|").map((value) => ({value})) }
                  }
                }
                if (~attrKeys.indexOf("status")) { fltSt.status = nextEl.attributes.status }
                if (~attrKeys.indexOf("visible") && ~["true", "false"].indexOf(nextEl.attributes.visible)) { fltSt.visible = (nextEl.attributes.visible === "true") }
                else if (~attrKeys.indexOf("hidden") && ~["true", "false"].indexOf(nextEl.attributes.hidden)) { fltSt.visible = (nextEl.attributes.hidden === "false") }
                else if (rz.arrContains(["modal", "drawer", "offcanvas"], nextEl.name)) { fltSt.visible = Boolean(nextEl.attributes?.visible === "true") }
                else { fltSt.visible = true } // Default
                if (~attrKeys.indexOf("disabled") && ~["true", "false"].indexOf(nextEl.attributes.disabled)) { fltSt.disabled = (nextEl.attributes.disabled === "true") }
                else if (~attrKeys.indexOf("enabled") && ~["true", "false"].indexOf(nextEl.attributes.enabled)) { fltSt.disabled = (nextEl.attributes.enabled === "false") }
                else { fltSt.disabled = false } // Default
                if (~attrKeys.indexOf("loading") && nextEl.attributes.loading === "true") { fltSt.loading = true }
                // else { fltSt.loading = false } // Default
              }
              else {
                fltSt.attributes = {}
              }

              ans[fullPath] = fltSt;
              // Children-elements
              if (nextEl.elements && nextEl.elements.length) { buildFlatState(nextEl.elements, fullPath) }
            }
          }
        });
      }
    };
    // ----------------------------------
    buildFlatState(elements, rootPath);
    // ----------------------------------
    return ans;
  }
};

export default uimin;
